export default class TripMatchesClient {
    constructor(apiClient) {
        this.tripMatchUri = '/v3/trip_matches';
        this.apiClient = apiClient;
        this.getTripMatch = this.getTripMatch.bind(this);
        this.postTripMatchDocument = this.postTripMatchDocument.bind(this);
        this.getTripMatchDocuments = this.getTripMatchDocuments.bind(this);
        this.postTripMatchSalesRecording = this.postTripMatchSalesRecording.bind(this);
        this.getTripMatchSalesRecordings = this.getTripMatchSalesRecordings.bind(this);
        this.postTripMatchChecklistItems = this.postTripMatchChecklistItems.bind(this);
        this.deleteTripMatchChecklistItem = this.deleteTripMatchChecklistItem.bind(this);
        this.getConversationSummaries = this.getConversationSummaries.bind(this);
        this.putTripMatch = this.putTripMatch.bind(this);
        this.putTripMatchAssignment = this.putTripMatchAssignment.bind(this);
        this.deleteTripMatchAssignment = this.deleteTripMatchAssignment.bind(this);
        this.putTripMatchStatus = this.putTripMatchStatus.bind(this);
        this.getTripMatchReviews = this.getTripMatchReviews.bind(this);
        this.postTripMatchReview = this.postTripMatchReview.bind(this);
        this.postTripMatchSearches = this.postTripMatchSearches.bind(this);
        this.getTripMatchTraveler = this.getTripMatchTraveler.bind(this);
        this.getTripMatchAgent = this.getTripMatchAgent.bind(this);
        this.postReviewRequest = this.postReviewRequest.bind(this);
    }
    putTripMatch(id, data, config) {
        return this.apiClient.put(`${this.tripMatchUri}/${id}`, data, config);
    }
    putTripMatchStatus(id, data, config) {
        return this.apiClient.put(`${this.tripMatchUri}/${id}/status`, data, config);
    }
    putTripMatchAssignment(id, agentId, config) {
        return this.apiClient.put(`${this.tripMatchUri}/${id}/assignments/${agentId}`, config);
    }
    deleteTripMatchAssignment(id, config) {
        return this.apiClient.delete(`${this.tripMatchUri}/${id}/assignments`, config);
    }
    getTripMatch(id, config) {
        return this.apiClient.get(`${this.tripMatchUri}/${id}`, config);
    }
    postTripMatchDocument(id, data, config) {
        return this.apiClient.post(`${this.tripMatchUri}/${id}/documents`, data, config);
    }
    getTripMatchDocuments(id, config) {
        return this.apiClient.get(`${this.tripMatchUri}/${id}/documents`, config);
    }
    postTripMatchSalesRecording(id, data, config) {
        return this.apiClient.post(`${this.tripMatchUri}/${id}/sales_recordings`, data, config);
    }
    getTripMatchSalesRecordings(id, config) {
        return this.apiClient.get(`${this.tripMatchUri}/${id}/sales_recordings`, config);
    }
    postTripMatchChecklistItems(id, data, config) {
        return this.apiClient.post(`${this.tripMatchUri}/${id}/checklist_items`, data, config);
    }
    deleteTripMatchChecklistItem(id, item, config) {
        return this.apiClient.delete(`${this.tripMatchUri}/${id}/checklist_items/${item}`, config);
    }
    getTripMatchTraveler(id, travelerId, config) {
        return this.apiClient.get(`${this.tripMatchUri}/${id}/travelers/${travelerId}`, config);
    }
    getTripMatchAgent(id, agentId, config) {
        return this.apiClient.get(`${this.tripMatchUri}/${id}/agents/${agentId}`, config);
    }
    getTripMatchReviews(id, config) {
        return this.apiClient.get(`${this.tripMatchUri}/${id}/reviews`, config);
    }
    postTripMatchReview(id, data, config) {
        return this.apiClient.post(`${this.tripMatchUri}/${id}/reviews`, data, config);
    }
    getConversationSummaries(id, config) {
        return this.apiClient.get(`${this.tripMatchUri}/${id}/conversation_summaries`, config);
    }
    postTripMatchSearches(data, config) {
        return this.apiClient.post('/v3/trip_match_searches', data, config);
    }
    postReviewRequest(id, config) {
        return this.apiClient.post(`${this.tripMatchUri}/${id}/review_requests`, {}, config);
    }
}
